import "../styles/Unauthorized/Unauthorized.css";
import { useTranslation } from "react-i18next";

const Unauthorized = () => {
    const handleGoBack = () => {
        window.history.back();
    };
    const { t } = useTranslation();


    return (
        <div className="unauthorized-container">
            <div className="unauthorized-box">
                <h1 className="unauthorized-heading">{t('unauthorized')}</h1>
                <p className="unauthorized-message" >
                    {t('page-permission')}
                </p>
                <button className="unauthorized-button" onClick={handleGoBack}>
                    {t('back')}
                </button>
            </div>
        </div>
    );
};

export default Unauthorized;